var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolarPanel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.163 3a.507.507 0 00-.494.406L5.413 10H12.7l.7-7H7.163zM12.4 13H4.844l-1.412 7.406a.501.501 0 00.493.594H11.6l.8-8zm3.013 0l-.8 8H25.4l-.8-8h-9.187zm8.887-3l-.7-7h-7.187l-.7 7H24.3zm3.313 3l.8 8h7.675c.312 0 .55-.288.494-.594L35.169 13h-7.556zm6.987-3l-1.256-6.594A.497.497 0 0032.85 3h-6.237l.7 7H34.6zM3.725 2.844A3.497 3.497 0 017.163 0H32.85a3.497 3.497 0 013.438 2.844l3.237 17A3.5 3.5 0 0136.088 24H21.507v5h5c.83 0 1.5.669 1.5 1.5s-.67 1.5-1.5 1.5h-13c-.832 0-1.5-.669-1.5-1.5s.668-1.5 1.5-1.5h5v-5H3.925a3.5 3.5 0 01-3.437-4.156l3.237-17z",
    fill: "#FF9C00"
  })));
}
export default SvgSolarPanel;